<div class="container-fluid mt-4">
  <div class="d-flex justify-content-between mb-3">
    <h4>
      <i class="fi fi-rr-drop-down"></i> მენიუ 
      <span *ngIf="currentLang == 'eng'">(EN)</span>
    </h4>
     <!-- დამატება -->
     <button class="btn btn-primary" (click)="openAddModal()">დამატება</button>
  </div>
  <div class="row mb-3">
   
    <div class="col-md-3">
     <button (click)="save()" class="btn btn-primary"  [disabled]="loadSave" *ngIf="isDrangDrop">
        <span *ngIf="loadSave" class="spinner-border spinner-border-sm" role="status" ></span>
        სტრუქტურის შენახვა
      </button>
    </div>
  </div>
 

  <app-spinner [loading]="load" text="იტვირთება..."></app-spinner>

  <app-error  *ngIf="!load && error" [title]="'შეცდომა ჩატვირთვის დროს'" (reload)="getMenu()"></app-error>
  
  <div *ngIf="!load">

    <div
      cdkDropList
      [cdkDropListData]="menuItems"
      (cdkDropListDropped)="drop($event)"
      cdkDropListOrientation="vertical"
    >
      <div *ngFor="let item of menuItems; trackBy: trackById" class="menu-drag-container" cdkDrag>

        <div cdkDragHandle class="drag-handle"><i class="fi fi-rr-arrows"></i></div>

        <app-menu-item
          [item]="item"
          [allMenu]="menuItems"
          (update)="onUpdate()"
          (dragChanged)="isDrangDrop = $event"
        ></app-menu-item>

        

        <ng-template cdkDragPlaceholder>
          <div class="menu-drag-container drag-placeholder"></div>
        </ng-template>
      </div>
    </div>

    
  </div>

</div>